import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { merchantList, merchantStatus, delMerchant } from './request';
import { methodList } from './../methodManage/request';
// import {intermediaryList} from './../../insurance/agencyManage/request';
import merchantModel from './merchantModel.vue';
import { customerResource } from '@/views/system/customerManage/request';
import informationModel from '@/views/template/components/informationModel';
export default {
  components: {
    merchantModel,
    informationModel
  },
  data() {
    return {
      merchantShow: false,
      typeList: [],
      intermediaryList: [],
      form: {
        type: undefined,
        search: '',
        customerId: undefined
      },
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 100
      }, {
        slots: {
          title: '账户主体'
        },
        dataIndex: 'accountName',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '账户类型'
        },
        dataIndex: 'type',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'type'
        }
      },
      // {title: '账号/商户号', dataIndex: 'mchid', key: '4', align: 'center'},
      {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 100,
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      informationShow: false
    };
  },
  created() {
    this.getDataFun();
    methodList().then(res => {
      this.typeList = res.items;
    });
    customerResource({
      isAll: 1
    }).then(res => {
      this.intermediaryList = res;
      this.intermediaryList.unshift({
        id: 0,
        name: this.$t('平台')
      });
    });
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    }
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    typeSee(val) {
      console.log(val);
      let arr = this.typeList.filter(item => item.id == val);
      return arr.length != 0 ? this.$t(arr[0].name) : '';
    },
    getDataFun() {
      let obj = this.form;
      obj.pageSize = this.pagination.pageSize;
      obj.page = this.pagination.current;
      merchantList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleAdd() {
      this.merchantShow = true;
      this.$nextTick(() => {
        this.$refs.merchantFrom.init({});
      });
    },
    handleEdit(val) {
      this.merchantShow = true;
      this.$nextTick(() => {
        this.$refs.merchantFrom.init(val);
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleOk(key) {
      this.pagination.current = 1;
      this.merchantShow = key == 'continueAdd' ? true : false;
      this.getDataFun();
    },
    checkedFun(val) {
      // if(!this.isAuth('home.customerUserStatus')){
      //     return false
      // }
      merchantStatus({
        paymentMethodId: val.id,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        console.log(res, res != 1);
        if (res.length != 0) {
          this.informationShow = true;
          this.$nextTick(() => {
            this.$refs.informationRef.init(res, 6);
          });
          return false;
        }
        this.$message.success(this.$t('修改成功'));
        this.getDataFun();
        // val.status = val.status == 1 ? 0 : 1;
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleDelete(val) {
      delMerchant({
        paymentMerchantId: val.paymentMerchantId
      }).then(res => {
        this.$message.success(this.$t('删除成功'));
        this.getDataFun();
      });
    }
  }
};